'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _teamManagementSelectors = require('./teamManagementSelectors');

var _userUtil = require('../../userUtil');

var _TeamInputForm = require('./form/TeamInputForm');

var _TeamInputForm2 = _interopRequireDefault(_TeamInputForm);

var _TeamMembersList = require('./membersList/TeamMembersList');

var _TeamMembersList2 = _interopRequireDefault(_TeamMembersList);

var _FormButton = require('../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

require('./TeamManagement.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        navigateToPayment: function navigateToPayment() {
            return dispatch((0, _reactRouterRedux.push)('/account/payment'));
        }
    };
};

var TeamManagementTitle = function TeamManagementTitle(_ref) {
    var currentUser = _ref.currentUser;
    return (0, _userUtil.isSubscribed)(currentUser) ? _react2.default.createElement(
        'h2',
        null,
        'Professional team plan'
    ) : _react2.default.createElement(
        'h2',
        null,
        'Who do you want to upgrade?'
    );
};

TeamManagementTitle.propTypes = {
    currentUser: _propTypes2.default.object
};

var TeamManagement = function TeamManagement(props) {
    return _react2.default.createElement(
        'div',
        { className: 'TeamManagement' },
        _react2.default.createElement(
            'div',
            { className: 'form-members' },
            _react2.default.createElement(TeamManagementTitle, props),
            _react2.default.createElement(
                'h3',
                null,
                'Team members ',
                _react2.default.createElement(
                    'span',
                    null,
                    '(minimum 2)'
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'team-list-scrollable' },
                _react2.default.createElement(_TeamMembersList2.default, props)
            ),
            _react2.default.createElement(_TeamInputForm2.default, props)
        ),
        _react2.default.createElement(
            'div',
            { className: 'form-footer' },
            _react2.default.createElement(
                _FormButton2.default,
                { className: 'primary',
                    disabled: !props.hasChanges || props.teamMembers.size <= 1,
                    onClickFn: props.navigateToPayment },
                (0, _userUtil.isSubscribed)(props.currentUser) ? 'Save changes & review payment' : 'Continue to payment'
            )
        )
    );
};

TeamManagement.propTypes = {
    teamMembers: _propTypes2.default.object,
    navigateToPayment: _propTypes2.default.func,
    currentUser: _propTypes2.default.object,
    hasChanges: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(_teamManagementSelectors.teamManagementModalSelctor, mapDispatchToProps)(TeamManagement);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/team/TeamManagement.js
// module id = 2093
// module chunks = 0